/**
 * どの機能にも属さない Query キー（auth・仕様グラフ全体の接頭辞）と、キーへ載せる言語の型。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business auth のキーと仕様グラフ全体を無効化する接頭辞、キーへ載せる表示言語の型を定義する。
 * @graph-connects none
 */
import type { SpecLocale } from '@cortex/domain-spec-console';

/** キーへ載せる表示言語。揃えていない言語で描いているときは `undefined`。 @graph-connects none */
export type LocaleKeyPart = SpecLocale | undefined;

/** auth の Query キー。 @graph-connects none */
export const authQueryKeys = {
  current: ['auth', 'current'] as const,
} as const;

/** 仕様グラフのキーすべてを無効化する接頭辞。 @graph-connects none */
export const specGraphCommonQueryKeys = {
  all: ['specGraph'] as const,
} as const;
